// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartReadyToGoRingExistingCustomerDocument = `
    mutation addToCartReadyToGoRingExistingCustomer($input: AddToCartReadyToGoRingInput!) {
  addToCartReadyToGoRingExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useAddToCartReadyToGoRingExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartReadyToGoRingExistingCustomerMutation, SchemaTypes.AddToCartReadyToGoRingExistingCustomerMutationVariables>(AddToCartReadyToGoRingExistingCustomerDocument);
};